// NOTE: Dependencies: jQuery, Defiant

(function($) {
	$.fn.accordion = function(options) {

		const $context = $(this);

		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			content: '.accordion__content',
			button: '.accordion__button',
			contentInitialized: 'initialized',
			contentActive: 'accordion__content--active',
			buttonActive: 'accordion__button--active'
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};

		methods.setCurrentSettings = function() {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
			settings.$button = $(settings.button);
		};

		// Bind events
		methods.events = function() {
			$context.find(settings.$button).off('click.accordion').on('click.accordion', function(event) {
				event.preventDefault();
				var $currentContext = $(this).closest('.accordion');

				var $this = $(this),
					buttonId = $this.data('id'),
					$contentId = $('#' + buttonId),
					$modules = $($(this).closest('.accordion')).find('> .module'),
					$checkedOptions = $($(this).closest('.accordion__content')).find('.product-item__checkbox:checked'), 
					$preFilterInitialized = $modules.find('#openFiltersMobile.accordion__content.initialized'),
					$preFilterActive = $modules.find('#openFiltersMobile.accordion__content.accordion__content--active'),
					$isMobileFilterActive = $($(this).closest('.accordion')).hasClass('accordion__content--active'),
					$contentOpened = $modules.find('.accordion__content.opened'),
					$buttonOpened = $modules.find('.accordion__button.opened');

				if($preFilterInitialized.length > 0) {
					$preFilterInitialized.toggleClass(settings.contentInitialized);

					if ($preFilterActive.length == 0) {
						$contentOpened.addClass(settings.contentActive);
						$buttonOpened.addClass(settings.buttonActive);
	
						$contentId.toggleClass(settings.contentInitialized);
	
						$contentId.toggleClass(settings.contentActive);
						$this.toggleClass(settings.buttonActive);
					} else {
						$contentId.removeClass(settings.contentActive);
						$this.removeClass(settings.buttonActive);
						$contentId.toggleClass(settings.contentInitialized);
					}					
				} else if ($preFilterActive.length > 0) {
					$contentId.removeClass(settings.contentActive);
					$this.removeClass(settings.buttonActive);

					$contentId.toggleClass(settings.contentInitialized);
				} else {
					if(buttonId == "openFiltersMobile") {
						$contentOpened.addClass(settings.contentActive);
						$buttonOpened.addClass(settings.buttonActive);

						$contentId.toggleClass(settings.contentInitialized);

						$contentId.toggleClass(settings.contentActive);
						$this.toggleClass(settings.buttonActive);
					} else {
						//only for mobile: keep opened only the one that is clicked, collapse the others
						if($isMobileFilterActive){
							//mobile
							$modules.find('.accordion__content').removeClass(settings.contentActive);
							$modules.find('.accordion__button').removeClass(settings.buttonActive);
						}

						$contentId.toggleClass(settings.contentActive);
						$this.toggleClass(settings.buttonActive);						
					}
				}
			});

		};

		methods.initContext = function() {
			methods.setCurrentSettings();
		};

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data('initialized');
		};

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {

			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this));

			// Run once methods when jquery plugin is called.
			methods.events(this);
		});
	};

	if ($('.accordion').length) {
		$('.accordion').each(function() {
			$(this).accordion();
		});
	}

}(jQuery));
